"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WearableRepresentation = void 0;
const wearable_category_1 = require("../../dapps/wearable-category");
const validation_1 = require("../../validation");
const wearable_body_shape_1 = require("./wearable-body-shape");
/** @alpha */
var WearableRepresentation;
(function (WearableRepresentation) {
    WearableRepresentation.schema = {
        type: 'object',
        properties: {
            bodyShapes: {
                type: 'array',
                items: wearable_body_shape_1.WearableBodyShape.schema,
                minItems: 1,
                uniqueItems: true
            },
            mainFile: {
                type: 'string',
                minLength: 1
            },
            contents: {
                type: 'array',
                items: {
                    type: 'string'
                },
                minItems: 1,
                uniqueItems: true
            },
            overrideHides: {
                type: 'array',
                items: wearable_category_1.WearableCategory.schema
            },
            overrideReplaces: {
                type: 'array',
                items: wearable_category_1.WearableCategory.schema
            }
        },
        additionalProperties: false,
        required: [
            'bodyShapes',
            'mainFile',
            'contents',
            'overrideHides',
            'overrideReplaces'
        ]
    };
    const schemaValidator = (0, validation_1.generateValidator)(WearableRepresentation.schema);
    WearableRepresentation.validate = (representation) => schemaValidator(representation) &&
        representation.contents.includes(representation.mainFile);
})(WearableRepresentation = exports.WearableRepresentation || (exports.WearableRepresentation = {}));
//# sourceMappingURL=representation.js.map